import event from 'event'
import serialize from 'form-serialize'
import { parse, stringify } from './querystring'

const ua = window.navigator.userAgent

export const hasTouch = require('has-touch')
export const isWechat = /micromessenger/i.test(ua) || typeof navigator.wxuserAgent !== 'undefined'
export const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
export const isAndroid = !isIos && /Android/i.test(ua)
export const isMac = /Mac/i.test(navigator.platform)
export const isIE = detectIE()
export const isDesktop = detectIE() || (window.matchMedia && window.matchMedia('(min-width: 767px)').matches)
export const isSafari = !isWechat && !isAndroid && ua.indexOf('Safari') > -1
export const ios_version = isIos ? iosVersion() : 0
export const weixin_version = weixinVersion()
export const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
export const hasStorage = window.localStorage == null ? false : true

export function domready(cb) {
  event.bind(document, 'DOMContentLoaded', cb)
}

export function torgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

export function getSearch() {
  if (location.search === '') {
    return {}
  }
  return parse(location.search)
}

export function loadScript(src, callback) {
  let s, r, t
  r = false
  s = document.createElement('script')
  s.type = 'text/javascript'
  s.src = src
  s.async = true
  s.charset = 'UTF-8'
  s.onload = s.onreadystatechange = function () {
    if (!r && (!this.readyState || this.readyState == 'complete')) {
      r = true
      if (callback) callback()
    }
  }
  s.onerror = e => { if (callback) callback(e) }
  t = document.getElementsByTagName('script')[0]
  t.parentNode.insertBefore(s, t)
}

function weixinVersion() {
  if (!isWechat) return null
  let m = ua.match(/micromessenger\/((\d+\.)?(\d+\.)*\d+)(\s|$)/i)
  if (!m) return null
  return parseFloat(m[1])
}

function iosVersion() {
  let m = ua.match(/OS\s(\d+(_\d+)?(_\d+)?)\s/i)
  if (!m) return null
  let str = m[1].replace(/_/g, '.')
  return parseFloat(str)
}

export function replaceState(obj) {
  obj = filterObj(obj)
  let loc = window.location
  let url = `${loc.pathname}?${stringify(obj)}${loc.hash}`
  if (!isWechat && window.history.replaceState) {
    window.history.replaceState({ path: url }, '', url)
  } else {
    loc.href = url
  }
}

function filterObj(obj) {
  let res = {}
  for (let key of Object.keys(obj)) {
    if (obj[key] != null) res[key] = obj[key]
  }
  return res
}

export function checkOnline() {
  if (window.navigator && navigator.onLine === false) return false
  return true
}

function detectIE() {
  return navigator.userAgent.toLowerCase().indexOf('msie') != -1
}

export function hasScrollbar() {
  if (window.innerHeight) {
    return document.body.offsetHeight > innerHeight
  } else {
    return document.documentElement.scrollHeight >
      document.documentElement.offsetHeight ||
      document.body.scrollHeight > document.body.offsetHeight
  }
}

export const hasFlex = (() => {
  let d = document.documentElement.style
  if (('flexWrap' in d) || ('WebkitFlexWrap' in d) || ('msFlexWrap' in d)) {
    return true
  }
  return false
})()

export function form(target) {
  let orig = target.prototype.onSubmit
  if (!orig) throw new Error('onSubmit method not found')
  target.prototype.onSubmit = function (e) {
    e.preventDefault()
    let obj = serialize(e.target, { hash: true })
    orig.call(this, event, obj)
  }
}
